/* © CNES */

import moment from 'moment';
import {
  CLOUD_COVER,
  DATASET,
  END_DATE_TIME,
  GRID_CODE,
  IDENTIFIER,
  INSTRUMENT,
  INSTRUMENT_MODE,
  ORBIT_ABSOLUTE,
  ORBIT_RELATIVE,
  PLATFORM,
  PPARAMETER,
  PROCESSING_LEVEL,
  PRODUCT_TYPE,
  START_DATE_TIME,
} from '../../components/shared/Constants';

/**
 * Filter Initial Values.
 */
 const startDate = new Date("30 December 2024 00:00 UTC")
 export const FilterInitValues = {
   [ORBIT_ABSOLUTE]: null,
   [ORBIT_RELATIVE]: null,
   [DATASET]: ['PEPS_S2_L1C'],
   dataProduct: null,
   [PLATFORM]: null,
   [PRODUCT_TYPE]: null,
   [PROCESSING_LEVEL]: null,
   [INSTRUMENT_MODE]: null,
   [CLOUD_COVER]: null,
   [START_DATE_TIME]: null,
   [END_DATE_TIME]: startDate.toISOString(),
   [IDENTIFIER]: null,
   [PPARAMETER]: null,
   [INSTRUMENT]: null,
   [GRID_CODE]: null,
 };

export const subMissionInitValues = {
  [DATASET]: null,
  [PLATFORM]: null,
  [PRODUCT_TYPE]: null,
  [PROCESSING_LEVEL]: null,
  [INSTRUMENT_MODE]: null,
  [CLOUD_COVER]: null,
};
